module.exports = __webpack_public_path__ + "static/media/arzon.d6a0bf46.jpg";